<script lang="ts">
  import Dialog from '../../../components/dialog/Dialog.svelte';
  import {StreamingChurchTV, ResiIO} from './Integrations';
  import {Integration, IntegrationUser} from '@/types/integrations';

  export let isUploadIntegrationsDialogOpen: boolean = false;
  export let integration: Integration;
  export let userIntegration: IntegrationUser | undefined;
  export let isUploading: boolean;
</script>

<Dialog bind:isDialogOpen={isUploadIntegrationsDialogOpen} useIfShow={true}>
  <div class="pointer-events-none flex h-full w-full items-end justify-center lg:items-center">
    <div
      class="pointer-events-auto relative h-auto w-full min-w-[280px] rounded-t-2xl border border-gray-300 bg-white p-12 p-4 shadow-lg dark:border-zinc-600 dark:bg-zinc-700 lg:max-w-[800px] lg:rounded-3xl"
    >
      {#if integration?.id == 1}
        <StreamingChurchTV bind:integration bind:userIntegration bind:isUploadIntegrationsDialogOpen bind:isUploading />
      {/if}
      {#if integration?.id == 2}
        <ResiIO bind:integration bind:userIntegration bind:isUploadIntegrationsDialogOpen bind:isUploading />
      {/if}
    </div>
  </div></Dialog
>
